<div
  *ngIf="step"
  class="fixed inset-0 z-50 flex items-end justify-center bg-black/40 sm:items-center sm:p-4"
  (click)="cancel.emit()"
>
  <!-- Step 1: confirm -->
  <div
    *ngIf="step === 'confirm'"
    role="dialog"
    aria-modal="true"
    aria-labelledby="wa-disconnect-title"
    (click)="$event.stopPropagation()"
    class="animate-slide-in w-full sm:max-w-[375px] bg-white rounded-t-[24px] sm:rounded-[24px] shadow-[0px_0px_30px_0px_rgba(35,32,66,0.08)] px-6 pt-9 pb-6 flex flex-col items-center gap-10"
  >
    <div class="w-full flex flex-col items-center gap-4">
      <h2
        id="wa-disconnect-title"
        class="w-full text-center text-[20px] leading-[24px] font-bold text-black"
      >
        Disconnect WhatsApp?
      </h2>
      <p class="w-full text-center text-[16px] leading-[24px] text-black">
        If you turn this off, IVY will stop sending cycle updates, reminders and
        insights on WhatsApp. You can reconnect anytime.
      </p>
    </div>

    <div class="w-full max-w-[308px] flex flex-col items-stretch gap-5">
      <p *ngIf="errorMessage" class="text-center text-sm text-red-600">
        {{ errorMessage }}
      </p>

      <button
        type="button"
        (click)="confirm.emit()"
        [disabled]="loading"
        class="h-[55px] rounded-full bg-[#2F2A4A] px-9 text-[15px] leading-[20px] font-bold tracking-[1.5px] text-white disabled:opacity-60 disabled:cursor-not-allowed"
      >
        {{ loading ? "DISCONNECTING…" : "DISCONNECT" }}
      </button>

      <button
        type="button"
        (click)="cancel.emit()"
        [disabled]="loading"
        class="h-[55px] rounded-full border border-[#2F2A4A] bg-white px-9 text-[15px] leading-[20px] font-bold tracking-[1.5px] text-black disabled:opacity-60 disabled:cursor-not-allowed"
      >
        CANCEL
      </button>

      <button
        type="button"
        (click)="contactSupport.emit()"
        class="text-center text-[16px] leading-[20px] font-bold text-[#5D38F1] underline"
      >
        Contact support
      </button>
    </div>
  </div>

  <!-- Step 2: why did you disconnect -->
  <div
    *ngIf="step === 'feedback'"
    role="dialog"
    aria-modal="true"
    aria-labelledby="wa-feedback-title"
    (click)="$event.stopPropagation()"
    class="animate-slide-in w-full sm:max-w-[375px] bg-white rounded-t-[24px] sm:rounded-[24px] shadow-[0px_0px_30px_0px_rgba(35,32,66,0.08)] px-5 pt-9 pb-6 flex flex-col items-center gap-7"
  >
    <h2
      id="wa-feedback-title"
      class="w-full max-w-[309px] text-center text-[20px] leading-[24px] font-bold text-black"
    >
      What didn’t work for you?
    </h2>

    <div class="w-full px-[10px] flex flex-col gap-[10px]">
      <button
        *ngFor="let reason of reasons"
        type="button"
        (click)="feedback.emit(reason)"
        class="w-full rounded-[4px] border border-[#DAD6FB] bg-white px-5 py-[10px] text-center text-[16px] leading-[24px] text-black transition-colors hover:bg-[#F6F4FF]"
      >
        {{ reason }}
      </button>
    </div>
  </div>
</div>
